<div [formGroup]="form">
    <mat-expansion-panel [expanded]="true">
        <mat-expansion-panel-header>
            <mat-panel-title class="fw-normal">Shipment Form</mat-panel-title>
        </mat-expansion-panel-header>
        <div
            cdkDropList
            formArrayName="dynamicFields"
            class="shipment-feature-dynamic-field-container"
            (cdkDropListDropped)="drop($event)"
        >
            @for (dynamicField of dynamicFields.controls; track dynamicField) {
                <app-dynamic-field-form
                    cdkDrag
                    class="shipment-feature-dynamic-field cursor-drag"
                    [form]="dynamicField"
                    [id]="$index"
                    [showDeleteButton]="showDeleteButton(dynamicField)"
                    [showDisabledToggle]="showDisabledToggle(dynamicField)"
                    (onDelete)="deleteDynamicField($event)"
                    [isPersistent]="isPersistentField(dynamicField.controls['name'].value)"
                    [dragEnabled]="true"
                    [showAutoPopulateAndMapping]="true"
                ></app-dynamic-field-form>
            }
        </div>
        @if (showAddDynamicFieldButton) {
            <div class="text-center m-3">
                <button
                    type="button"
                    mat-stroked-button
                    id="add-dynamic-field"
                    class="mt-2"
                    (click)="addDynamicField()"
                >
                    Add Dynamic Field
                </button>
            </div>
        }
        <app-input-customization></app-input-customization>
        <app-background-image-upload
            [formGroup]="form"
            [images]="orgBackgroundImages"
            [removeShadowControl]="removeShadowControl"
        ></app-background-image-upload>
    </mat-expansion-panel>
</div>
